import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  min-height: 100vh;
  background-color: white;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const PlanSection = styled.section`
  display: flex;
  justify-content: flex-end;
  width: 50%;
  min-height: 100vh;
  padding: 72px 60px 24px 24px;

  @media (max-width: 1024px) {
    padding: 36px 24px 24px;
  }

  @media (max-width: 767px) {
    min-height: 0px;
    justify-content: center;
    width: 100%;
  }
`;

export const PlanContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const HomeLink = styled.a`
  margin-bottom: 47px;

  @media (max-width: 1024px) {
    margin-bottom: 32px;
  }
`;

export const PaymentSection = styled.section`
  width: 50%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray[200]};
  padding: 64px 24px 60px 90px;

  @media (max-width: 1024px) {
    padding: 76px 24px 60px;
  }

  @media (max-width: 767px) {
    width: 100%;
    min-height: 0px;
    justify-content: center;
    padding: 36px 24px 60px;
  }
`;

export const TrialHeading = styled.h1`
  ${({ theme }) => theme.heading["3"]};
  margin-bottom: 12px;
`;

export const NameLabel = styled.label`
  align-self: flex-start;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.gray[700]};
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  margin: 0 0 8px;
`;

export const NameInput = styled.input`
  width: 100%;
  height: 42px;
  border: 2px solid ${({ theme }) => theme.colors.gray[600]};
  border-radius: 4px;
  background-color: white;
  outline: none;
  overflow: hidden;
  padding: 0 11px;
  transition-delay: 0s;
  transition-duration: 0.1s;
  transition-property: color;
  transition-timing-function: ease;
  margin: 0 0 10px;
  font-size: 15px;
  font-family: "Circular";
  color: ${({ theme }) => theme.colors.gray[700]};

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray[600]};
    font-weight: 500;
  }
`;

export const FlashError = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.accent.red};
  border-radius: 3px;
  padding: 8px 16px;
  box-sizing: border-box;
  color: white;
  text-align: center;
  margin-top: 21px;
`;

export const PaymentContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 300px;

  @media (max-width: 767px) {
    align-items: center;
    max-width: 100%;
  }
`;
